export default {
  initialize: state => ({
    type: 'PAGINATION_INITIALIZE',
    state,
  }),
  setActivePage: activePage => ({
    type: 'PAGINATION_SET_ACTIVE_PAGE',
    activePage,
  }),
  setPageCursors: pageCursors => ({
    type: 'PAGINATION_SET_PAGE_CURSORS',
    pageCursors,
  }),
  setItemsPerPage: itemsPerPage => ({
    type: 'PAGINATION_SET_ITEMS_PER_PAGE',
    itemsPerPage,
  }),
  setItemsPerPageOptions: itemsPerPageOptions => ({
    type: 'PAGINATION_SET_ITEMS_PER_PAGE_OPTIONS',
    itemsPerPageOptions,
  }),
  setItemCount: itemCount => ({
    type: 'PAGINATION_SET_ITEM_COUNT',
    itemCount,
  }),
  reset: () => ({
    type: 'PAGINATION_RESET',
  }),
};
